import { render, staticRenderFns } from "./QuotaBar.vue?vue&type=template&id=69c34470"
import script from "./QuotaBar.vue?vue&type=script&lang=js"
export * from "./QuotaBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports